// ----------------------------------------
// ------------ pdp accordians ------------
let allpdpAccordianEls = document.querySelectorAll(
  ".oj-main-product__accordion-item"
);
if (allpdpAccordianEls) {
  allpdpAccordianEls.forEach((el) =>
    el.addEventListener("click", (e) => {
      accordianHandlerCustom(e, el);
    })
  );
  function accordianHandlerCustom(e, el) {
    el.closest(".oj-main-product__accordion-item").classList.toggle("is-open");
  }
}
